import React from "react";
import LanguageConfirmationPopUpModalComponent from "../../components/Std/LanguageConfirmation/LanguageConfirmationPopUpModalComponent";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";

const LanguageConfirmationModalPopup = (props) => {
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  return (
    <LanguageConfirmationPopUpModalComponent
      closeRemoveModal={closeRemoveModal}
      {...props}
    />
  );
};
export default LanguageConfirmationModalPopup;
